export default "__VITE_ASSET__DWpmEW53__"